import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const EventsItem = ({ id, title, startTime, endTime, location }) => {
  const startDate = moment(startTime);

  const renderTime = (startTime) => {
    const startDate = moment(startTime);
  
    return (
      <div className="events-item-event-info-time">
        {startDate.format('HH:mm')}
      </div>
    );
  };
 
  return (
    <Link to={`/events/${id}`} className="events-container-item">
      <div className="events-container-hub-list-upper">
        <div className="events-item-event-date-holder">
          <div className="events-item-event-date">
            <span className="events-item-event-date-month">
              {startDate.format('MMM').toUpperCase()}
            </span>
            <span className="events-item-event-date-day">{startDate.format('DD')}</span>
          </div>
        </div>
        <div className="events-container-hub-list-content">
          <p className="events-container-hub-list-title">{title}</p>
           {renderTime(startTime)}
          <p className="events-container-hub-list-description">{location}</p>
        </div>
        <FontAwesomeIcon
          icon={['fas', 'chevron-right']}
          className="events-back-link-icon"
        />
      </div>
    </Link>
  );
};

export default EventsItem;
